import ReceiptPosition from '../../types/api/receipt-position'

export interface ReceiptPositionFormFilters {
    materialTypeDocId?: string
    materialWidth?: number | string
    amount?: number | string
    initiatorDocId?: string
}

const filterReceiptPositionsByForm = <T extends ReceiptPosition>(
    positions: T[],
    formFilters: ReceiptPositionFormFilters = {}
): T[] => {
    const { materialTypeDocId, materialWidth, amount, initiatorDocId } = formFilters

    const widthNum =
        materialWidth != null && materialWidth !== '' ? Number(materialWidth) : undefined
    const hasWidth = widthNum != null && !Number.isNaN(widthNum)

    const amountNum = amount != null && amount !== '' ? Number(amount) : undefined
    const hasAmount = amountNum != null && !Number.isNaN(amountNum)

    if (!materialTypeDocId && !hasWidth && !hasAmount && !initiatorDocId) {
        return positions
    }

    return positions.filter(pos => {
        if (materialTypeDocId && pos.material?.material_type?.documentId !== materialTypeDocId) {
            return false
        }

        if (hasWidth && pos.material?.width !== widthNum) {
            return false
        }

        if (hasAmount && pos.amount !== amountNum) {
            return false
        }

        if (initiatorDocId) {
            const positionInitiatorDocId =
                pos.initiator?.documentId ?? pos.order_request?.initiator?.documentId
            if (positionInitiatorDocId !== initiatorDocId) {
                return false
            }
        }

        return true
    })
}

export default filterReceiptPositionsByForm
